import { render, staticRenderFns } from "./reademail.vue?vue&type=template&id=16825e92&scoped=true"
import script from "./reademail.vue?vue&type=script&lang=js"
export * from "./reademail.vue?vue&type=script&lang=js"
import style0 from "./reademail.vue?vue&type=style&index=0&id=16825e92&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "16825e92",
  null
  
)

export default component.exports